import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "relative w-[650px] flex flex-col gap-10 text-main-100 text-sm overflow-hidden"
};
const _hoisted_2 = {
  class: "flex items-center gap-6 mb-4"
};
const _hoisted_3 = {
  class: "text-xs"
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal");
  return _ctx.$state.ui.slangoNews ? (_openBlock(), _createBlock(_component_Modal, {
    key: 0,
    onclose: () => _ctx.$state.ui.slangoNews = undefined
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("i", {
      class: "icon-chatboe text-3xl"
    }, null, -1)), _createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("p", {
      class: "text-xl font-bold"
    }, "Novedades", -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(this.$formatDate({
      date: _ctx.$state.ui.slangoNews.createAt,
      format: '{day2} de {monthName} de {year4}'
    })), 1)])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "h-px w-full bg-main-50"
    }, null, -1))]), _createElementVNode("div", {
      class: "flex flex-col gap-6",
      innerHTML: $options.computedNews
    }, null, 8, _hoisted_4)])]),
    _: 1
  }, 8, ["onclose"])) : _createCommentVNode("", true);
}